import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import '../config'

// const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
// isMobile ? import('../App_mobile.css'):import('../App.css');

export default class bottom extends Component {
    constructor(props){
        super(props)
        this.state={
            isMobile:false,
            data:[
                {
                title:'了解详情',
                sub01:'产品技术',
                sub02:'解决方案',
                sub03:'关于我们'
                },
                {
                title:'合作',
                sub01:'产品技术',
                sub02:'解决方案',
                    sub03:'关于我们'
                }
            ],
            erweima:[
                {
                    img:require('../image/mengduogongzhonghao.jpg'),
                    img01:require('../image/fuwuhao.jpg'),
                    sub01:'公众号二维码'
                },
                {
                    img:require('../image/mengduoxiaochengxu.jpg'),
                    img01:require('../image/xiaochengxu.jpg'),
                    sub01:'小程序二维码'
                }
            ]
        }       
    }
      
    render() {
        return (
            <div>
                {global.constants.isMobile && this.renderMobile()}
                {!global.constants.isMobile && this.renderWeb()}
            </div>
        )
    }

    renderMobile = () => (
        <div className="shenqingMobile">
            <div className="title" style={{color:"#ffffff",fontSize:"15px",textAlign:"center",paddingTop:"3rem",margin:"0 0 1rem 0"}}>多 样 化 智 能 平 台，一 键 免 费 申 请</div>
            <Link to="/trial" style={{textDecoration:"none"}}>
                <div className="try"  >申请试用</div>
            </Link>
            {/* <div className="try" >联系我们</div> */}
            <div className="QC">
                {
                    this.state.erweima.map((item)=>{
                        return(
                                <div>
                                    {global.constants.channel==="mengduo"&&
                                        <img src={item.img} style={{width:"16.8vw"}}></img>
                                    }
                                    {global.constants.channel==="hongchuang"&&
                                        <img src={item.img01} style={{width:"16.8vw"}}></img>
                                    }
                                    <div style={{ color:"white",marginTop:"0.5rem", fontSize: '12px' }}>{item.sub01}</div>
                                </div>
                            )
                        }
                    )
                }
            </div>
            <div style={{ fontSize: '11px', fontFamily: 'PingFangSC-Regular', color: '#A9C8FF' }}>
                Copyright@2017-2018zhiliang
            </div>
        </div>
    )

    renderWeb = () => (
        <div>
            <div class="hole-bottom-contain">
                <div className="hole-bottom-contain-top">
                    <img className="hole-bottom-contain-top-img" src={require('../image/logo.svg')} />
                    <Link to="/Trial" className="hole-bottom-contain-top-txt">申请试用</Link>
                </div>
                <div className="hole-bottom-line" />
                <div className="contact-us-contain">
                    <div className="contact-us-title">联系我们</div>
                    <div className="contact-us-content">
                        {[
                            { title: '商务合作：', value: '78661232@qq.com' },
                            { title: '代理合作：', value: '78661232@qq.com' },
                            { title: '售前咨询：', value: '+86 186 6029 7512' },
                            { title: '企业地址：', value: '山东省青岛市市北区敦化路119号凯景大厦701室' },
                        ].map(({ title, value }) => (
                            <div className="contact-us-content-r" key={title}>
                                <div className="contact-us-content-t">{title}</div>
                                <div className="contact-us-content-v">{value}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="box05">
                    {
                        this.state.erweima.map((item)=>{
                            return(
                                <div className="erweima">
                                    {global.constants.channel==="mengduo"&&
                                        <img src={item.img} className="bottom-erweima-img"></img>
                                    }
                                    {global.constants.channel==="hongchuang"&&
                                        <img src={item.img01} className="bottom-erweima-img"></img>
                                    }
                                    <div className="bottom-erwe-name">{item.sub01}</div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className="banquan">
                {global.constants.channel==="hongchuang"&&
                    <div className="company-name">Copyright@2006-2018青岛红创众投科技发展有限公司</div>
                }
                {global.constants.channel==="mengduo"&&
                    <div className="company-name">Copyright@2006-2018mengduo梦多</div>
                }
            </div>
        </div>
    )
    
    renderWeb1 = () => (
        <div style={{ whiteSpace:"nowrap", overflowY:"none" }}  >
            <div className="shenqing">
                <div className="intro05">多样化智能平台，一键免费申请</div>
                <div className="try">
                    <div className="viewtext01">
                        <Link to="/Trial" className="lijishenqing">立即申请</Link>
                    </div>
                    <div className="viewtext02">
                        <div className="lianxiwomen">联系我们</div> 
                    </div>
                </div>
            </div>
            <div className="bottom">
                <div className="box04">
                    {
                        this.state.data.map((item)=>{
                            return(
                                <div className="liaojiexiangqing">
                                    <div className="bottom01">{item.title}</div>
                                    <Link to="/product" className="bottom02">{item.sub01}</Link>
                                    <Link to="/solution" className="bottom02">{item.sub02}</Link>
                                    <Link to="/about" className="bottom02">{item.sub03}</Link>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="box05">
                    {
                        this.state.erweima.map((item)=>{
                            return(
                                <div className="erweima">
                                    {global.constants.channel==="mengduo"&&
                                        <img src={item.img} className="erweima-img"></img>
                                    }
                                    {global.constants.channel==="hongchuang"&&
                                        <img src={item.img01} className="erweima-img"></img>
                                    }
                                    <div className="name">{item.sub01}</div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className="banquan">
                {global.constants.channel==="hongchuang"&&
                    <div className="company-name">Copyright@2006-2018青岛红创众投科技发展有限公司</div>
                }
                {global.constants.channel==="mengduo"&&
                    <div className="company-name">Copyright@2006-2018mengduo梦多</div>
                }
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/bottom.js